import { Vector3 } from 'three';

export enum BoxElementName {
  BOX = 'BOX',
  BAG = 'BAG',
  TAPE = 'TAPE',
  LOGO1 = 'LOGO1',
  LOGO2 = 'LOGO2',
  LOGO3 = 'LOGO3',
  LOGO4 = 'LOGO4',
  OVERHANG = 'OVERHANG',
}

export const DEFAULT_2D_VECTOR_VIEW = new Vector3(0, 15, 0);
export const DEFAULT_3D_VECTOR_VIEW = new Vector3(20, 15, 45);
export const IMAGE_EXPORT_3D_VECTOR_VIEW = new Vector3(
  -11.21079424604087,
  10.61845053729797,
  12.83484950558495,
);
export const EXPORT_IMAGE_MIME_TYPE = 'image/jpeg';

export const LOGO_WIDTH = 0.00005;
export const LOGO_HEIGHT = 0.6;
export const LOGO_DEPTH = 0.6;
export const LOGO_MAX_WIDTH_PERCENTAGE = 0.6;
export const LOGO_BAG_MAX_WIDTH_PERCENTAGE = 0.55;
export const OVERHANG_LINE_COLOR = 0XFF0000;
export const OVERHANG_MAX_GAP = 0.2;
